<template>
	<div class="mx-2 h-6 w-px bg-won-gray-light" />
</template>


